/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "actions";

import AdminShopHeader from "components/pages/admin/shops/AdminShopHeader";
import AdminProductSearch from "components/widgets/admin/AdminProductSearch";
import AdminOrderSearch from "components/widgets/admin/AdminOrderSearch";
import "components/elements/main/index.scss";
import { checkUserAllowed } from "helpers/utils.js";
import CustomSectionCreator from "components/CustomSectionCreator";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ViewListIcon from "@mui/icons-material/ViewList";


const AdminShopOverall = (props) => {

  const [state] = useState({
    layoutColumns: 3,
  });

    const {
        match, userDetails
    } = props;

    const { shopId } = match.params;


    useEffect(() => {
    props.adminResetSearchShops();
    document.getElementById("color").setAttribute("href", "#");
  }, []);

    const renderShopProducts = () => {
        if (checkUserAllowed(userDetails.userlevel, "products")) {
            return <AdminProductSearch {...props} shopId={shopId} isShop={true} limit={4} colSize={state.layoutColumns} />;

        } else {
            return  <div>Not available </div>;
        }
    }

    const renderShopOrders = () => {
        if (checkUserAllowed(userDetails.userlevel, "orders")) {
            return <AdminOrderSearch {...props} shopId={shopId} isShop={true} limit={4} colSize={state.layoutColumns} />;

        } else {
            return  <div>Not available </div>;
        }
    }

    return (
        <div>
            <AdminShopHeader {...props} />
            <CustomSectionCreator icon={<ViewListIcon />} title="Products">
                {
                    renderShopProducts()
                }
            </CustomSectionCreator>

            <CustomSectionCreator icon={<ShoppingCartIcon />} title="Orders">
                {
                    renderShopOrders()
                }
            </CustomSectionCreator>

        </div>
    );
};

AdminShopOverall.propTypes = {
    adminResetSearchShops: PropTypes.func.isRequired,
  bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
};

// Mapping Props and State.
const AdminShopOverallComponent = connect(
  ({ adminProducts, bootupInfo }) => ({
    bootupInfo,
      userDetails: bootupInfo.userDetails,
    reqStatus: adminProducts.reqStatus,
    isLoading: adminProducts.isLoading,
    serviceError: adminProducts.serviceError,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(AdminShopOverall);

export { AdminShopOverallComponent as default };
